// packages/components/src/doctor-ai/DiagnosisSummaryCard.tsx
import React from 'react';
import { Card, Badge } from '@dopomogai/ui';
import { Lightbulb, ListChecks } from 'lucide-react';
import type { DiagnosisData } from '@dopomogai/types'; // Assuming this type is created

export const DiagnosisSummaryCard: React.FC<{ data: DiagnosisData }> = ({ data }) => {
  const confidenceColor = data.confidence.toLowerCase().includes('high')
    ? 'green'
    : data.confidence.toLowerCase().includes('medium')
    ? 'yellow'
    : 'gray';

  return (
    <Card noHoverEffect className="bg-slate-50 border-slate-300">
      <div className="p-5">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h3 className="text-lg font-bold text-slate-800">{data.diagnosis}</h3>
            <p className="text-sm text-slate-600 mt-1">{data.reasoning}</p>
          </div>
          <Badge text={data.confidence} accentColor={confidenceColor} />
        </div>

        <div className="mt-6">
          <h4 className="flex items-center gap-2 text-md font-semibold text-slate-700">
            <ListChecks size={18} />
            Recommended Next Steps
          </h4>
          <ul className="mt-3 list-disc list-inside space-y-1 text-slate-600 text-sm">
            {data.recommendations.map((rec, index) => (
              <li key={index}>{rec}</li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
};